goog.provide("shadow.js.shim.module$dayjs$locale$ja");
goog.provide("module$shadow_js_shim_module$dayjs$locale$ja");
shadow.js.shim.module$dayjs$locale$ja = shadow.js.nativeProvides["dayjs/locale/ja"] = require("dayjs/locale/ja");
module$shadow_js_shim_module$dayjs$locale$ja.default = shadow.js.shim.module$dayjs$locale$ja;
